import React from 'react';
import PropTypes from 'prop-types';
import {Status} from '@fiverr/fit';
import '@fiverr/i18n/singleton';
import './style.scss';
import classNames from 'classnames';

const BADGE_CASES = {
    FEATURED: 'featured',
    CHOICE: 'choice',
    PRO: 'pro',
    LIMITED: 'limited',
    HIGH_COMPLETION: 'high_completion',
    TALENT: 'talent',
    NOW: 'now',
    HIRE_AGAIN: 'hire_again',
    BUY_IT_AGAIN: 'buy_it_again'
};

const Badge = ({ type, className, tooltipPositionClass }) => {
    const leftAlign = [BADGE_CASES.LIMITED, BADGE_CASES.TALENT].includes(type),
        badgeClasses = classNames({
            'featured': type === BADGE_CASES.FEATURED,
            'available-now': type === BADGE_CASES.NOW,
            'pro-badge': type === BADGE_CASES.PRO,
            'limited-edition': type === BADGE_CASES.LIMITED,
            'high-completion-rate': type === BADGE_CASES.HIGH_COMPLETION,
            'rising-talent': type === BADGE_CASES.TALENT,
            'card-badge': type === BADGE_CASES.PRO,
            'outline': type === BADGE_CASES.PRO
        }, 'badge-hint', 'js-badge-hint', tooltipPositionClass);
    const ExclusiveBadge = {
        [BADGE_CASES.FEATURED]: () => (
            <Status classes={badgeClasses}
                data-hint={i18n.t('badges.featured.tooltip')}>
                {i18n.t('badges.featured.caption')}
            </Status>
        ),
        [BADGE_CASES.CHOICE]: () => (
            <Status classes="quality-choice">{i18n.t('badges.fiverrs_choice.caption')}</Status>
        ),
        [BADGE_CASES.NOW]: () => (
            <Status classes={badgeClasses}
                data-hint={i18n.t('badges.available_now.tooltip')}>
                <i/> {i18n.t('badges.available_now.caption')}
            </Status>
        ),
        [BADGE_CASES.PRO]: () => (
            <span className={badgeClasses} data-hint={i18n.t('badges.pro.tooltip')}/>
        ),
        [BADGE_CASES.LIMITED]: () => (
            <Status classes={badgeClasses}
                data-hint={i18n.t('badges.limited_edition.tooltip')}>
                {i18n.t('badges.limited_edition.caption')}
            </Status>
        ),
        [BADGE_CASES.HIGH_COMPLETION]: () => (
            <Status classes={badgeClasses}
                data-hint={i18n.t('badges.very_reliable.tooltip')}>
                <i/> {i18n.t('badges.very_reliable.caption')}
            </Status>
        ),
        [BADGE_CASES.TALENT]: () => (
            <Status classes={badgeClasses}
                data-hint={i18n.t('badges.rising_talent.tooltip')}>
                {i18n.t('badges.rising_talent.caption')}
            </Status>
        ),
        [BADGE_CASES.HIRE_AGAIN]: () => (
            <Status classes="hire-again">
                {i18n.t('badges.hire_again.caption')}
            </Status>
        ),
        [BADGE_CASES.BUY_IT_AGAIN]: () => (
            <Status classes="buy-it-again">
                {i18n.t('badges.buy_it_again.caption')}
            </Status>
        )
    }[type] || null;

    const classes = ['gig-badge'];
    className && classes.push(className);
    leftAlign && classes.push('left');
    type === BADGE_CASES.TALENT && classes.push('rising-talent');

    return <span className={classes.join(' ')}><ExclusiveBadge/></span>;
};

Badge.propTypes = {
    type: PropTypes.string.isRequired,
    className: PropTypes.string,
    tooltipPositionClass: PropTypes.string
};

export default Badge;



// WEBPACK FOOTER //
// ./src/shared/badge/index.js